import api from "./axios";

export const getUsers = () => api.get("/users");

/**
 * Department-scoped roster for assignee pickers.
 *
 * Second argument is optional so the existing positional callers keep working;
 * pass a department to scope the roster to it.
 */
export const getVisibleUsers = (projectId, departmentView) => {
  const params = {};
  if (projectId) params.projectId = projectId;
  if (departmentView) params.departmentView = departmentView;
  return api.get("/users/visible", { params });
};

export const getPendingProjectInvitations = () => api.get("/projects/invitations/pending");

export const respondToProjectInvitation = (id, action) =>
  api.post(`/projects/invitations/${id}/respond`, { action });

export const getPendingUsers = () => api.get("/auth/users/pending");
export const approveUser = (id, status) => api.put(`/auth/users/${id}/approve`, { status });
